import hellojs from '../../vendor/hello.js'

export default function () {
  return hellojs
  // install Google Drive driver
    .init({
      gdrive: {
        name: 'Google Drive',

        base: 'https://accounts.google.com/o/oauth2/v2/',

        oauth: {
          version: 2,
          auth: 'https://accounts.google.com/o/oauth2/v2/auth',
          grant: 'https://www.googleapis.com/oauth2/v4/token',
          response_type: 'code',
        },

        login(p) {
          // sets popup size to fit NetDocuments login screen
          p.options.popup.width = 950;
          p.options.popup.height = 600;
        },

        scope: {
          appdata: 'https://www.googleapis.com/auth/drive.appdata',
          files: 'https://www.googleapis.com/auth/drive.file',
          // 'drive' is read/write to all files in your google drive
          // to use a pre-existing folder for upload, we need to allow access to all files, even those not
          // created with google drive.
          drive: 'https://www.googleapis.com/auth/drive',
        },

        scope_delim: ' ',

        login: function(p) {
          // set access_type to 'offline' so that we get a refresh token
          p.qs.access_type = 'offline';

          // The default here is 'select_account', but if that is used, we wont always get a refresh token.
          p.qs.prompt = 'consent';

          // Reauthenticate
          if (p.options.force)
            p.qs.approval_prompt = 'force';
        }
      }
    })
    // Initialize Driver instance
    // TODO: can we stick some of this configuration up above?
    .init(
      { gdrive: window.Drupal.settings.INTEGRATIONS_GDRIVE_APP_ID },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      }
    )('gdrive'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/GoogleDriveAuthenticator.jsx